import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { fget } from "../../../../API/callsAPI";
import Loader from "../../../Utilities/Loader/Loader";
import UsersViewer from "../../../Utilities/UsersViewer/UsersViewer";

const columns = [
  { id: "name", label: "Rank", minWidth: 170 },
  { id: "code", label: "User", minWidth: 100, align: "center" },
  {
    id: "population",
    label: "Total Score",
    minWidth: 170,
    align: "center",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "size",
    label: "Role",
    minWidth: 170,
    align: "center",
    format: (value) => value.toLocaleString("en-US"),
  },
];

const UserScoreRankingTable = ({ projectId }) => {
  const [rankingList, setRankingList] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const getUsersRankings = async () => {
    setIsLoaded(false);
    try {
      const res = await fget({
        url: `score-rankings/?project=${projectId}`,
      });
      setRankingList(res?.data);
      setIsLoaded(true);
    } catch (error) {
      console.log(error);
      setIsLoaded(true);
    }
  };

  useEffect(() => {
    getUsersRankings();
  }, []);

  const commonTableCell = {
    color: "white",
    borderBottom: "1px solid gray",
    fontSize: {
      sm: "10px",
      md: "10px",
      lg: "12px",
      xl: "14px",
    },
  };
  return (
    <Paper
      sx={{
        width: "100%",
        overflow: "hidden",
        bgcolor: "transparent",
        color: "white",
      }}
    >
      {isLoaded ? (
        <TableContainer sx={{ maxHeight: { lg: 500, xl: 760 } }}>
          <Table stickyHeader aria-label="sticky table" sx={{ pr: 2 }}>
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{
                      minWidth: column.minWidth,
                      backgroundColor: "#1B1D28",
                      color: "gray",
                      border: "1px solid gray !important",
                    }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rankingList?.length ? (
                <>
                  {rankingList?.map((ranking, index) => {
                    return (
                      <TableRow
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={ranking.code}
                      >
                        <TableCell align="left" sx={{ ...commonTableCell }}>
                          {index + 1}
                        </TableCell>
                        <TableCell align="center" sx={{ ...commonTableCell }}>
                          <UsersViewer
                            assignedUser={[ranking?.user]}
                            selectedTask={""}
                            editable="no"
                          />
                        </TableCell>
                        <TableCell align="center" sx={{ ...commonTableCell }}>
                          {ranking?.score}
                        </TableCell>
                        <TableCell align="center" sx={{ ...commonTableCell }}>
                          User Role
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </>
              ) : (
                <>No User Found</>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <Box>
          <Loader />
        </Box>
      )}
    </Paper>
  );
};

export default UserScoreRankingTable;
